import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuditRecord, BatchDetailsResponse } from '../../models/dashboard.model';
import { DashboardService } from '../../services/dashboard.service';
import { details } from '../../configs/batch-details.config';
import { $Locale } from '@hubio/hubio-common-components';
import { StringUtilService } from '@core/services/string-util.service';
import { ModalComponent } from '@core/components/modal/modal.component';
import { MatDialog } from '@angular/material/dialog';
import { CLICKABLE_AUDITS } from '../../configs/clickable-rows.config';

@Component({
  selector: 'app-file-details',
  templateUrl: './file-details.component.html',
  styleUrls: ['./file-details.component.scss']
})
export class FileDetailsComponent implements OnInit {

  public tseqno;
  public detailsItems;
  public data: BatchDetailsResponse
  public breadcrumbsSteps = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dashboardService: DashboardService,
    public $Locale: $Locale,
    private stringUtilService: StringUtilService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.tseqno = this.route.snapshot.params["tseqno"];
    this.dashboardService.getBatchDetails({ tseqno: this.tseqno }).subscribe((res) => {
      this.data = res;
      this.breadcrumbsSteps.push({
        label: this.$Locale.get("files"),
        relativeRoute: "/communic8/"
      })
      if (!this.data.details || Object.keys(this.data.details).length == 0) {
        this.breadcrumbsSteps.push({
          label: this.tseqno,
          relativeRoute: this.router.url
        });
        return;
      };
      this.breadcrumbsSteps.push({
        label: this.data.details.filename as string,
        relativeRoute: this.router.url
      });
      this.detailsItems = [
        {
          label: "File Name",
          value: this.data.details[details.fileName]
        },
        {
          label: "Number of Brokers",
          value: this.data.details[details.brokerCount]
        },
        {
          label: "Brokers Not Found",
          value: this.data.details[details.brokerNotFoundCount]
        },
        {
          label: "Created",
          value: this.stringUtilService.formatDateTime(
            new Date(this.data.details[details.created] as string).getTime()
          )
        },
        {
          label: "Status",
          value: this.data.details[details.status]
        },
        {
          label: "Number of Errors",
          value: this.data.details[details.errorCount]
        }
      ]
    })
  }

  handleRowClick(broker: AuditRecord) {
    const { aid, astatus, error_count } = broker;
    if (CLICKABLE_AUDITS[astatus] || error_count > 0) {
      this.router.navigateByUrl(`${this.router.url}/broker/${aid}`);
    }
  }

  retry() {
    this.dashboardService.retryBatch({ tseqno: this.tseqno }).toPromise().then((res) => {
      this.data.details.retry = false;
      const amount = res.transactionsResent
      const display = `${amount ?? ''} transaction${amount > 1 ? 's' : ''}`
      this.dialog.open(ModalComponent, {
        data: {
          title: "File resend initiated",
          message: [
            `Resending ${display} for file "${this.data.details[details.fileName]}".`,
            `The result will be reflected in this file's status.`
          ]
        }
      })
    })
  }

}
